import Link_ from 'next/link';

const Link: any = Link_;

export default Link;
